export * from './mapAggregateDataToSourceData';
